goog.provide("shadow.js.shim.module$src$svg$inform$bubble_left_text_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$bubble_left_text_svg");
shadow.js.shim.module$src$svg$inform$bubble_left_text_svg = shadow.js.nativeProvides["src/svg/inform/bubble-left-text.svg"] = shadow$bridge("src/svg/inform/bubble-left-text.svg");
module$shadow_js_shim_module$src$svg$inform$bubble_left_text_svg.default = shadow.js.shim.module$src$svg$inform$bubble_left_text_svg;
